import { SystemBase2 } from "@inter-ikea-core/core-toolbox";
import { ColliderShapeComponent, ComponentIds, Cuboid, HierarchyUtils, Vector, } from "@inter-ikea-core/core";
import { getRightUprightsOffsetFromLeft } from "../functions/interactiveBoaxelSection";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { NO_MOUNTING_RAIL } from "../constants/errors";
import { MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS } from "../constants/connectorKeys";
import { findUniqueConnections } from "../utils/connectorHelpers";
import { UPDATE } from "@inter-ikea-storagetwo/range/dist/constants";
export default class AdaptMountingRailBoundingBoxSystem extends SystemBase2 {
    constructor(core) {
        super(ComponentIds.IS_DRAGGED_COMPONENT_ID, ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.core = core;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "AdaptMountingRailBoundingBoxSystem";
        this.mandatoryComponents = [COMPONENT_IDS.UPRIGHT_COMPONENT];
        this.scaleMountingRail = (upright) => {
            const parent = HierarchyUtils.parent(upright);
            if (!parent)
                throw new Error(NO_MOUNTING_RAIL);
            const width = getRightUprightsOffsetFromLeft(parent, upright);
            this.scaleEntityInCore(new Vector(width, 20, 20), parent);
        };
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        const mountingRail = HierarchyUtils.parent(_entity);
        if (!mountingRail)
            throw new Error(NO_MOUNTING_RAIL);
        mountingRail.removeComponent(ComponentIds.COLLIDER_SHAPE_COMPONENT_ID);
    }
    onRemoveComponent(_entity, _oldComponent) {
        super.onRemoveComponent(_entity, _oldComponent);
        this.scaleMountingRail(_entity);
    }
    onAddComponent2(_entity, _newComponent) {
        super.onAddComponent2(_entity, _newComponent);
        const hostKey = _newComponent.connections[0].hostConnector.key;
        if (!MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS.includes(hostKey))
            return;
        this.scaleMountingRail(_entity);
    }
    onUpdateComponent2(_entity, _oldComponent, _newComponent) {
        super.onUpdateComponent2(_entity, _oldComponent, _newComponent);
        const { action, connections } = findUniqueConnections(_oldComponent.connections, _newComponent.connections);
        if (action !== UPDATE)
            return;
        const hostKey = connections[0].hostConnector.key;
        if (!MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS.includes(hostKey))
            return;
        this.scaleMountingRail(_entity);
    }
    scaleEntityInCore(size, entity) {
        const offset = -(800 - size.X) / 2;
        const cubiod = Cuboid.fromSize(size).move(new Vector(offset, 0, 0));
        const colliderShapeComponent = new ColliderShapeComponent(cubiod, ["box"]);
        entity.addComponent(colliderShapeComponent);
    }
}
